<script>
    export let title = "";
    export let url = "";
</script>

<style>
    img {
        min-width: 250px;
    }
</style>

<header class="header">
    <div>
        {#if url}
            <a href="{url}">
                <svg xmlns="http://www.w3.org/2000/svg" width="12.387" height="21.667" viewBox="0 0 12.387 21.667">
                    <path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M14.985,17.024l8.2-8.192A1.548,1.548,0,0,0,20.99,6.646L11.7,15.928a1.545,1.545,0,0,0-.045,2.135l9.327,9.346a1.548,1.548,0,1,0,2.193-2.187Z" transform="translate(-11.251 -6.194)" fill="#00627d"/>
                </svg>
            </a>
        {/if}
        {#if title}
          <h1>{ title }</h1>
        {:else}
           <img src="/svg/logo.svg" alt="Coop Membership" />
        {/if}
    </div>
    <img src="/svg/header-waves.svg" class="waves" alt="Waves" aria-hidden="true" />
</header>